<template>
  <v-container>
    <!--app-view-toolbar-->
    <app-view-toolbar :title="headline" :showBackButton="true"></app-view-toolbar>
    <template v-if="viewDataIsLoaded">
      <v-form ref="formEdit">
        <v-row>
          <v-col>
            <v-text-field
              type="text"
              label="Rubrik"
              outlined
              v-model="viewData.assignmentData.name"
              :rules="[formRules.required]"
              validate-on-blur
              required
              maxlength="30"
            ></v-text-field>
            <v-textarea
              label="Beskrivning"
              outlined
              v-model="viewData.assignmentData.description"
              :rules="[formRules.required]"
              validate-on-blur
              required
              :auto-grow="true"
            ></v-textarea>
          </v-col>
        </v-row>
        <div class="text-h6">Startdatum &amp; tid</div>
        <v-row>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="startDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="viewData.assignmentData.startDate"
                  readonly
                  label="Datum"
                  outlined
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  :rules="[formRules.required, formRules.date]"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="viewData.assignmentData.startDate"
                @input="startDateMenu = false"
                dark
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              ref="startTimeMenu"
              v-model="startTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="viewData.assignmentData.startTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="viewData.assignmentData.startTime"
                  readonly
                  label="Tid"
                  outlined=""
                  prepend-icon="mdi-clock-outline"
                  v-bind="attrs"
                  v-on="on"
                  :rules="[formRules.required, formRules.time]"
                  validate-on-blur
                  required
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="startTimeMenu"
                v-model="viewData.assignmentData.startTime"
                full-width
                dark
                format="24hr"
                :allowed-minutes="allowedMinutes"
                @click:minute="$refs.startTimeMenu.save(viewData.assignmentData.startTime)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <div class="text-h6">Slutdatum &amp; tid</div>
        <v-row>
          <v-col cols="12" sm="6">
            <v-menu
              v-model="endDateMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="viewData.assignmentData.endDate"
                  readonly
                  label="Datum"
                  outlined
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-on="on"
                  :rules="[formRules.required, formRules.date]"
                  required
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="viewData.assignmentData.endDate"
                @input="endDateMenu = false"
                dark
                first-day-of-week="1"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" sm="6">
            <v-menu
              ref="endTimeMenu"
              v-model="endTimeMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="viewData.assignmentData.endTime"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="viewData.assignmentData.endTime"
                  readonly
                  label="Tid"
                  outlined=""
                  prepend-icon="mdi-clock-outline"
                  v-bind="attrs"
                  v-on="on"
                  :rules="[formRules.required, formRules.time]"
                  validate-on-blur
                  required
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="endTimeMenu"
                v-model="viewData.assignmentData.endTime"
                full-width
                dark
                format="24hr"
                :allowed-minutes="allowedMinutes"
                @click:minute="$refs.endTimeMenu.save(viewData.assignmentData.endTime)"
              ></v-time-picker>
            </v-menu>
          </v-col>
        </v-row>
        <!--qualifications--->
        <div class="text-h6">Kvalifikationer</div>
        <v-row>
          <v-col>
            <!--qualification-form-fields-->
            <app-qualification-form-fields :data="viewData.assignmentData" :presetData="viewData.qualificationPresetData" mode="assignment"></app-qualification-form-fields>
          </v-col>
        </v-row>
        <!--collectiveAgreement--->
        <div class="text-h6">Lön</div>
        <v-radio-group
          v-model="viewData.assignmentData.cagId"
          label="Kollektivavtal*"
          :rules="[formRules.checked(viewData.assignmentData.cagId)]"
          validate-on-blur
          class="mb-2"
        >
          <v-radio
            v-for="cag in viewData.assignmentData.cag_ar"
            :key="cag.id"
            :label="cag.name"
            :value="cag.id"
          ></v-radio>
        </v-radio-group>
        <v-text-field
          label="Ev. timlön"
          outlined
          v-model="viewData.assignmentData.hourlySalary"
          type="number"
          :rules="[formRules.positiveInteger(viewData.assignmentData.hourlySalary, { min: 1, max: 10000 })]"
          min="1"
          max="10000"
          validate-on-blur
          suffix="SEK"
          class="xAmount"
        ></v-text-field>
        <div class="text-h6">Start &amp; mål</div>
        <v-row class="ph-12 pb-6">
          <v-col>
            <!--google-map-->
            <app-google-map
              :markers="markers"
              :addMarkerButtons="addMarkerButtons"
              :data="viewData.assignmentData.mapData"
              :useMap="false"
            ></app-google-map>
          </v-col>
        </v-row>
      </v-form>
      <!--app-form-bottom-->
      <app-form-bottom
        :postWasInvalid="postWasInvalid"
        :errorOutput="errorOutput"
        @onSubmit="doSubmit"
        @onErrorOk="postWasInvalid = false"
        :loader="loader"
        :removable="!isNew"
        @onRemoveDialogOpen="removeDialog = true"
        @onRemoveDialogClose="removeDialog = false"
        @onRemove="remove"
        txtAnObject="Jobb"
        txtTheObject="Jobbet"
        :removeDialog="removeDialog"
      ></app-form-bottom>
    </template>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import ViewToolbar from '../components/ViewToolbar'
import FormBottom from '../components/FormBottom'
import QualificationFormFields from '../components/QualificationFormFields'
import GoogleMap from '../components/GoogleMap'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { googleMapMixin } from '../mixins/googleMap'
import { snackBarBus } from '../main'
import { mapGetters } from 'vuex'

export default {
  name: 'Assignment',
  components: {
    'app-snack-bar': SnackBar,
    'app-google-map': GoogleMap,
    'app-form-bottom': FormBottom,
    'app-qualification-form-fields': QualificationFormFields,
    'app-view-toolbar': ViewToolbar
  },
  mixins: [generalMixin, urlMixin, googleMapMixin],
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      viewData: {

/*        assignmentData: {
          name: '',
          description: '',
          startDate: '',
          startTime: '',
          endDate: '',
          endTime: '',
          startPos: '',
          endPos: '',
          qaoId_ar: []
        },
        elementData: {
          qualificationAreaData_ar: []
        }
        */
      },
      postWasInvalid: false,
      errorOutput: '',
      showBankIdDialog: false,
      bankIdToken: null,
      startDateMenu: false,
      startTimeMenu: false,
      endDateMenu: false,
      endTimeMenu: false,
      viewDataIsLoaded: false,
      headline: '',
      removeDialog: false,
      loader: true,
      markers: [
        {
          label: 'startPos',
          position: null,
          name: 'Start',
          icon: {
            url: require('../assets/markers/start.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        },
        {
          label: 'endPos',
          position: null,
          name: 'Mål',
          icon: {
            url: require('../assets/markers/goal.png'),
            scaledSize: {width: 64, height: 64},
            labelOrigin: {x: 16, y: -10}
          }
        }
      ],
      addMarkerButtons: [
        {
          label: 'startPos',
          text: 'Ange som start'
        },
        {
          label: 'endPos',
          text: 'Ange som mål'
        }
      ]
    }
  },
  watch: {
    viewDataIsLoaded(value) {
      if (value) {
        //set headline
        this.headline = (this.isNew) ? 'Nytt jobb' : 'Redigera jobb'
        //possibly update positions in markerData
        let label, position
        for (let marker of this.markers) {
          label = marker.label
          position = this.viewData.assignmentData.mapData[label]
          if (position.lat !== 0 && position.lng !== 0) {
            //label has real position, update marker in markers (that is invoked in google-map)
            marker.position = position
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters(['access_token', 'loggedInData']),
    companyName() {
      return this.loggedInData.agentData.name
    },
    isNew() {
      return this.id == 0
    },
  },
  methods: {
    // receives a place object via the autocomplete component
    allowedMinutes: m => m % 5 === 0,
    onViewData(viewData) {
      this.viewData = viewData
      this.viewDataIsLoaded = true
    },
    doSubmit() {
      const formIsValid = this.$refs.formEdit.validate()
      if (!formIsValid) {
        snackBarBus.$emit('message', 'Formuläret ej komplett ifyllt')
        return
      }
      if (!this.isValidCoordinate(this.viewData.assignmentData.mapData.startPos)) {
        snackBarBus.$emit('message', 'Du måste ange startposition')
        return
      }
      if (!this.isValidCoordinate(this.viewData.assignmentData.mapData.endPos)) {
        snackBarBus.$emit('message', 'Du måste ange målposition')
        return
      }
      this.loader = true
      //post data to API
      let postData = {
        assignmentData: this.viewData.assignmentData,
        agentData: this.loggedInData.agentData,
        newQprData: this.viewData.qualificationPresetData.newQprData
      }
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/assignment/' + this.id)
      axios.put(url, postData, config)
        .then(response => {
//          console.log('put response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //refresh loggedInData via onAuth
            let dataToDispatch = {
              loggedInData: response.data.returnData.loggedInData
            }
            this.$store.dispatch('onAuth', dataToDispatch).then(() => {
              //go to dashboard
              this.$router.replace({ name: 'company-dashboard'})
            })
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
            this.postWasInvalid = true
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
          this.postWasInvalid = true
        })
    },
    remove() {
      //hide dialog
      this.removeDialog = false
      //show loader
      this.loader = true
      //set config for axios request with Authorization header
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let url = this.url_composeApiUrl('/assignment/' + this.id)
      axios.delete(url, config)
        .then(response => {
//          console.log('delete response', response)
          this.loader = false
          if (response.data.success) {
            //success
            //go to dashboard
            this.$router.replace({ name: 'company-dashboard'})
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            //still logged in
            this.errorOutput = this.generalParseErrorArray(response.data.returnData.error_ar)
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    }
  },
  created() {
    //get view data
    let config = {
      headers: {
        'Authorization': this.access_token
      }
    }
    //post data to API
    let postData = {
      agentData: this.loggedInData.agentData
    }
    let url = this.url_composeApiUrl('/assignment/edit/' + this.id)
    axios.post(url, postData, config)
      .then(response => {
        this.loader = false
//        console.log('get response', response)
        if (response.data.success) {
          //success
          this.onViewData(response.data.returnData.viewData)
        } else if (this.onNonSuccessApiCall(response.data.returnData)) {
          snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
        }
      })
      .catch(error => {
        this.loader = false
        snackBarBus.$emit('message', error.toString())
      })
  }
}
</script>

<style>
input.pac-target-input {
  width:100%;
}
</style>